import styled from "styled-components";
import { borderRadius, spacing, typographyMixin } from "@magicbi/ui-library";

export const Strip = styled.span<{ $columns: number; $portrait: boolean; $size: "sm" | "md" }>`
  display: grid;
  grid-template-columns: ${({ $columns, $portrait, $size }) =>
    $portrait ? ($size === "sm" ? "1.375rem" : "6rem") : `repeat(${$columns}, minmax(0, 1fr))`};
  gap: ${({ $size }) => ($size === "sm" ? spacing[0.5] : spacing[1])};
  align-items: start;
  width: 100%;
  min-width: 0;

  > * {
    min-width: 0;
    aspect-ratio: ${({ $portrait }) => ($portrait ? "8.5 / 11" : "16 / 9")};
  }
`;

export const More = styled.span`
  display: grid;
  place-items: center;
  border: 1px dashed ${({ theme }) => theme.colors.border.default};
  border-radius: ${borderRadius.md};
  ${typographyMixin("caption", 2)}
  color: ${({ theme }) => theme.colors.text.secondary};
`;
